import axios from 'utils/axios';
import { AxiosResponse } from 'axios';

export const deleteServicePackageAttachment = (data: any): Promise<AxiosResponse> => {
  const { id } = data;
  return axios.delete(`/api/v1/servicepackages/mfo/attachments/${id}`);
};
